import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Button, Header, Message, Icon } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import moment from "moment-timezone";
import i18n from "./../i18n";

import RescheduleExamTable from "../components/RescheduleExamTable";
import BulkUploadModal from "../components/BulkUploadModal";
import {
  fetchApprovedBookings,
  updateExamToDelete,
  deleteExamCreator,
  updateBookingToEdit,
  updateDeleteModal,
  updateShowOnlyFutureBookings,
  rescheduleBooking,
  fetchBookings,
  cancelBooking,
  fetchBooking,
} from "./../reducers/booking";
import MainMenu from "./../components/MainMenu";
import BookingReschedule from "./../components/emails/BookingReschedule";
import { addNotification } from "./../reducers/notification";
import parseTimezone from "../lib/helperServices";
import { sendEmail } from "./../lib/emailService";
import { createBulkBooking } from "../lib/bookingServices";

class Schedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayError: false,
      openDelete: false,
      error: "",
      showRescheduleModal: false,
      statusFilter: "approved",
      showConfirmationModal: false,
      showOnlyFuture: true,
      modalText: {
        header: "",
        msg: "",
      },
      showBulkModal: false,
    };
    this.handleUpdateBooking = this.handleUpdateBooking.bind(this);
    this.openBulkModal = this.openBulkModal.bind(this);
    this.closeBulkModal = this.closeBulkModal.bind(this);
    this.handleBulkUploaded = this.handleBulkUploaded.bind(this);
    this.renderBulkResults = this.renderBulkResults.bind(this);
  }
  handleUpdateBooking(data) {
    return new Promise((resolve, reject) => {
      const { examDate, booking, sendRescheduleEmail } = data;
      this.props
        .rescheduleBooking(
          {
            examDate,
            id: booking.id,
            user_id: booking.user.user_id,
          },
          this.state.statusFilter,
          this.state.showOnlyFuture
        )
        .then((response) => {
          const updatedBooking = response.booking;
          const userData = response.userData;

          let timezone = parseTimezone(userData.attributes.timezone[0]);

          this.props.addNotification({
            title: this.props.t("general.success"),
            message:
              "Exam rescheduled successfully for: " +
              moment(updatedBooking.examDate).format("MMMM Do YYYY - h:mm A"),
            type: "success",
            timeout: true,
          });

          if (sendRescheduleEmail) {
            let userLanguage = "";

            if (userData.attributes && userData.attributes.locale) {
              userLanguage = i18n.getFixedT(userData.attributes.locale[0]);
            } else {
              userLanguage = i18n.getFixedT("en");
            }

            sendEmail({
              to: userData.email,
              subject: userLanguage("RescheduleExam.resheduleEmailSubject"),
              component: (
                <BookingReschedule
                  t={userLanguage}
                  name={`${userData.firstName} ${userData.lastName}`}
                  examTitle={booking.exam.title}
                  timezone={userData.attributes.timezone[0]}
                  bookingDate={moment(updatedBooking.examDate)
                    .tz(timezone)
                    .format("MMMM Do YYYY - h:mm A")}
                  duration={booking.exam.duration}
                  examRules={
                    booking.exam.student_rules
                      ? booking.exam.student_rules
                      : "N/A"
                  }
                />
              ),
            }).then(() => {
              resolve();
            });
          } else {
            resolve();
          }
        })
        .catch((e) => {
          console.error("Error during rescheduleBooking:", e);
          this.props.addNotification({
            title: this.props.t("general.error"),
            message: "Rescheduling Error.",
            type: "error",
            timeout: true,
          });

          reject(e);
        });
    });
  }
  openBulkModal() {
    this.setState({ showBulkModal: true });
  }
  closeBulkModal() {
    this.setState({ showBulkModal: false });
  }
  handleBulkUploaded(success) {
    this.props.addNotification({
      title: this.props.t(success ? "general.success" : "general.error"),
      message: success ? "Bulk bookings processed." : "Bulk upload failed.",
      type: success ? "success" : "error",
      timeout: true,
    });
  }
  renderBulkResults(results) {
    const successfulResults = results.filter((result) => result.success);
    const userNotFoundResults = results.filter(
      (result) =>
        !result.success &&
        result.error &&
        (result.error.includes("User not found") ||
          result.error.includes("user not found") ||
          result.error.includes("User does not exist") ||
          result.error.includes("user does not exist"))
    );
    const otherErrorResults = results.filter(
      (result) => !result.success && !userNotFoundResults.includes(result)
    );

    return (
      <>
        {successfulResults.length > 0 && (
          <div style={{ marginBottom: "1em" }}>
            <Header as="h5" color="green">
              <Icon name="check circle" />
              Successful Bookings ({successfulResults.length})
            </Header>
            {successfulResults.map((result, idx) => (
              <Message positive key={`success-${idx}`}>
                <Message.Header>
                  Success: Booking created for {(result.booking && result.booking.username) || `user ID: ${result.booking && result.booking.user_id}`}
                </Message.Header>
                {result.booking && (
                  <div style={{ marginTop: "8px", fontSize: "14px" }}>
                    <strong>Exam:</strong> {result.booking.exam_name || (result.booking.exam && result.booking.exam.title)}<br />
                    <strong>Date:</strong> {result.booking.booking_date || result.booking.examDate}<br />
                    <strong>Institution:</strong> {result.booking.learning_institution || result.booking.institution}<br />
                    {result.booking.username && <><strong>Username:</strong> {result.booking.username}<br /></>}
                  </div>
                )}
              </Message>
            ))}
          </div>
        )}

        {userNotFoundResults.length > 0 && (
          <div style={{ marginBottom: "1em" }}>
            <Header as="h5" color="orange">
              <Icon name="user times" />
              Users Not Found in eProctor ({[...new Set(userNotFoundResults.map((result) => result.booking && result.booking.username).filter(Boolean))].length})
            </Header>
            <Message warning>
              <Message.Header>Missing Users:</Message.Header>
              <div style={{ marginTop: "8px", fontSize: "14px" }}>
                {[...new Set(userNotFoundResults.map((result) => result.booking && result.booking.username).filter(Boolean))].join(", ")}
              </div>
            </Message>
          </div>
        )}

        {otherErrorResults.length > 0 && (
          <div>
            <Header as="h5" color="red">
              <Icon name="exclamation triangle" />
              Other Errors ({otherErrorResults.length})
            </Header>
            {otherErrorResults.map((result, idx) => (
              <Message negative key={`error-${idx}`}>
                <Message.Header>Error: {result.error}</Message.Header>
                {result.booking && (
                  <div style={{ marginTop: "8px", fontSize: "14px" }}>
                    <strong>Failed booking data:</strong> {result.booking.username || result.booking.exam_name || "Unknown"}
                  </div>
                )}
              </Message>
            ))}
          </div>
        )}
      </>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Container>
          <MainMenu />
          <div style={{ marginBottom: "1em", display: "flex", gap: "1em", justifyContent: "flex-end" }}>
          <button
            className="ui button green"
            onClick={this.openBulkModal}
          >
            Bulk Add Bookings
          </button>
        </div>
        <BulkUploadModal
          open={this.state.showBulkModal}
          onClose={this.closeBulkModal}
          title="Bulk Add Bookings"
          downloadLabel="Download Booking Template"
          templateFilename="booking_template.csv"
          templateHeaders={[
            "Username",
            "Booking Date (YYYY-MM-DD HH:mm AST)",
            "Learning Institution",
            "Exam Name",
          ]}
          templateSampleRow="john.doe@example.com,2025-12-15 10:00,PSKN,Math Exam"
          formatInstructions={
            <p>
              <strong>Important CSV Formatting:</strong><br/>
              • Fields are separated by commas (,)<br/>
              • Times should be in 24-hour format (AST timezone)<br/>
            </p>
          }
          minColumns={4}
          rowToItem={(row) => ({
            username: row[0],
            booking_date: row[1],
            learning_institution: row[2],
            exam_name: row[3],
          })}
          uploadItems={createBulkBooking}
          renderResults={this.renderBulkResults}
          onUploaded={this.handleBulkUploaded}
        />
      </Container>
      <RescheduleExamTable
        handleUpdateBooking={this.handleUpdateBooking}
      />
      </React.Fragment>
    );
  }
}

export default withTranslation()(
  connect(
    (state) => ({
      kc: state.keycloak,
      bookings: state.bookings,
    }),
    {
      addNotification,
      fetchBookings,
      fetchBooking,
      fetchApprovedBookings,
      updateExamToDelete,
      deleteExamCreator,
      updateBookingToEdit,
      updateDeleteModal,
      updateShowOnlyFutureBookings,
      rescheduleBooking,
      cancelBooking,
    }
  )(Schedule)
);
